<template>
  <el-dialog :width="width" title="驳回" :visible.sync="visible" append-to-body>
    <el-form ref="form" :model="data" label-width="85px" v-loading="isLoading">
      <div class="row-head">
        <span>选择驳回节点</span>
      </div>
      <el-table :data="RejectNodes" border>
        <el-table-column label="选择" align="center" width="60px">
          <template slot-scope="{row}">
            <el-checkbox v-model="row.Checked" @change="onSelect(row)"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="NodeName" label="节点名称" />
      </el-table>
      <div class="row-head">
        <span>意见</span>
      </div>
      <el-input type="textarea" v-model="data.Comment" placeholder="请输入意见"></el-input>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="isLoading" @click="onHandle">确 定</el-button>
      <el-button @click="onClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      api: require("@/api/wf/instance").default,
      data: {
        WorkId: 0,
        Comment: "",
        RejectNodeId: null,
      },
      RejectNodes: [],
      isLoading: false,
      visible: false,
    };
  },
  computed: {
    width() {
      return this.$store.state.isMB ? "86%" : "500px";
    },
  },
  methods: {
    openCreate(data) {
      this.data.WorkId = data.WorkId;
      this.data.Comment = data.Comment;
      this.RejectNodes = data.RejectNodes.map((x) => {
        return { ...x, Checked: false };
      });
      this.visible = true;
    },
    onSelect(row) {
      console.log("select", row);
      var value = row.Checked;
      this.RejectNodes.forEach((x) => (x.Checked = false));
      row.Checked = value;
      this.data.RejectNodeId = row.NodeId;
    },
    onHandle() {
      if (!this.data.RejectNodeId) {
        this.$message({
          customClass: "my-msg",
          type: "warning",
          message: "请选择驳回节点",
        });
        return;
      }
      this.isLoading = true;
      this.api.reject(this.data).then((res) => {
        this.isLoading = false;
        if (res.Code == 0) {
          this.$message({
            customClass: "my-msg",
            type: "success",
            message: res.Msg,
          });
          this.$emit("close-saved");
          this.visible = false;
        } else {
          this.$message({
            customClass: "my-msg",
            type: "error",
            message: res.Msg,
          });
        }
      });
    },
    onClose() {
      if (this.isLoading) {
        this.$message({
          customClass: "my-msg",
          type: "warning",
          message: "任务执行中，请稍候",
        });
      } else {
        this.visible = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tree-btn {
  display: inline-block;
  width: 40px;
  text-align: center;
}
</style>